import HttpRequest from '@/lib/axios'
const axios = new HttpRequest()
export default axios






//////////////////
// WEBPACK FOOTER
// ./app/api/index.js
// module id = null
// module chunks = 